import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, take } from "keautils";
import { validation, formfields, makeUncontrolled } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { StatusRastreoDTOList } from "./listastatus";

import { RastreoGuias } from "./guias";
import * as globals from "app/resources/globals";

type Entity = models.RastreoModel;
export interface Props {
    value: Entity;
    stateValue: Entity;
    onChange: (x: Entity) => void;
    onSetState: (x: Entity) => void;
}
const limite = 10;
class RastreoGuiasIndexNoRx extends React.PureComponent<Props> {
    constructor(props) {
        super(props);
        this.state = { folios: [] };
    }

    propsValue = (x: Props) => x.value;
    stateValue = (x: Props) => x.stateValue;
    value = createSelectorRx(this.propsValue, this.stateValue, (props, state) => state.forzarState ? state : props);


    handleOnAgregarFolio = (folio: string) => {
        const value = this.value(this.props);

        const oldValue = value.folios;
        const filtrados = oldValue.filter(x => x != folio);
        const newValue = take([folio, ...filtrados], limite)
        this.handleOnChange({ folios: newValue, forzarState: false });
    }

    handleOnQuitarTodo = async () => {
        if (await kea.yesno("¿Quitar todas las guías de este rastreo?")) {
            this.handleOnChange({ folios: [], forzarState: false });
        }
    }

    handleOnChange = (x: models.RastreoModel) => {
        this.props.onChange(x);
        this.props.onSetState(x);
    }

    handleOnRecuperarGuias = async () => {
        this.props.onChange(this.props.stateValue);
    }

    handleOnQuitarFolio = (x: string) => {
        const value = this.value(this.props);
        this.handleOnChange({ folios: value.folios.filter(folio => folio != x), forzarState: false });
    }

    render() {
        const value = this.value(this.props);
        return (
            <RastreoGuias
                folios={value.folios}
                onAgregarFolio={this.handleOnAgregarFolio}
                onQuitarTodo={this.handleOnQuitarTodo}
                verMensajeMaximo={value.folios.length >= 5}
                verRecuperarGuias={value.folios.length == 0 && this.props.stateValue.folios.length > 0}
                onRecuperarGuias={this.handleOnRecuperarGuias}
                onQuitarFolio={x => this.handleOnQuitarFolio(x)}
            />
        )
    }
}

const initial: models.RastreoModel = { folios: [], forzarState: false };
const uncontrolled = makeUncontrolled<Props>("value", "onChange", initial)(RastreoGuiasIndexNoRx);
const RastreoGuiasIndexRx = componentToRx(uncontrolled);

export const Rastreo = kea.defaultProps(RastreoGuiasIndexRx, {
    stateValue: globals.state.map(x => x.rastreo || { folios: [], forzarState: false }),
    onSetState: (x: Entity) => globals.setState(prev => ({ ...prev, rastreo: x }))
}) as any as React.ComponentClass<{}>;



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/rastreo/rastreo.tsx